module.exports = __webpack_public_path__ + "static/media/member_invite_sample.7d8bfe7b.csv";